/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CittadinoRegistrationForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TerminiVersioneDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface RegistraCittadinoRequestParams {
    cittadinoRegistrationForm: CittadinoRegistrationForm;
    xRecaptchaToken?: string;
}


export interface CittadinoRegistrazioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Obsoleto: risponde sempre enabled&#x3D;false.
     * Endpoint pubblico mantenuto solo per i client non aggiornati. I documenti del cittadino sono per comune e si accettano dopo il login (GET /api/v1/cittadino/comuni/{slug}/documenti/da-accettare).
     * @endpoint get /api/v1/cittadino/registrazione/termini

     * @deprecated
     */
    getTerminiRegistrazioneCittadino(extraHttpRequestParams?: any): Observable<TerminiVersioneDTO>;

    /**
     * Registra un nuovo cittadino con credenziali locali (self-service).
     * Endpoint pubblico protetto da reCAPTCHA, disponibile solo se il login locale è abilitato (civeshub.auth.local.enabled). Crea un utente Keycloak disabilitato con ruolo ROLE_cittadino, lo User locale (accountActivated&#x3D;false) e il UserProfile col codice fiscale, quindi invia la mail di attivazione. L\&#39;account resta inerte finché l\&#39;email non è verificata (PUT /api/v1/account/verification).
     * @endpoint post /api/v1/cittadino/registrazione
* @param requestParameters
     */
    registraCittadino(requestParameters: RegistraCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

}
